import {FC} from 'react';
import ReturnHomeButton from '../common/ReturnHomeButton';
import image404 from '../../../../assets/images/auth/404-error.png';

const Error404: FC = () => {
	return (
		<>
			{/* begin::Title */}
			<h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops!</h1>
			{/* end::Title */}

			{/* begin::Text */}
			<div className='fw-semibold fs-6 text-gray-500 mb-7'>We can't find that page.</div>
			{/* end::Text */}

			{/* begin::Illustration */}
			<div className='mb-3'>
				<img src={image404} className='mw-100 mh-300px' alt='' />
			</div>
			{/* end::Illustration */}

			<ReturnHomeButton />
		</>
	);
};

export {Error404};
